import firebase from 'firebase';
import { v4 } from 'uuid';
import Firebase from "./Firebase";

class UserApi {
  constructor() {
    this.currentUserClaims = undefined;
  }

  async getUserData(currentUser) {
    try {
      let document = await firebase.firestore().collection('users').doc(this.__getId()).get();
      let sanitizedData = document.data();
      if (sanitizedData === undefined || sanitizedData === null) {
        sanitizedData = { answers: {} };
      }
      if (sanitizedData.answers === undefined) {
        sanitizedData.answers = {};
      }
      return sanitizedData;
    } catch (e) {
      await this.crashReport(e.message);
      return Promise.reject(e);
    }
  }

  async crashReport(stackTrace) {
    try {
      let result = await firebase.firestore().collection('users').doc(this.__getId()).collection('crashes').doc(v4()).set({
        when: firebase.firestore.Timestamp.fromDate(new Date()),
        stackTrace: JSON.stringify(stackTrace)
      });
      return result;
    } catch (e) {
      console.error("We're hopeless...")
    }
  }

  async search(keyword) {
    try {
      let res = await firebase.functions().httpsCallable('search')({ keyword });
      return res.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async impersonate(uuid) {
    try {
      let result = await Firebase.fetch('/user/' + uuid + '/impersonate', {
        method: 'POST'
      });
      return result.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async unimpersonate() {
    try {
      let result = await Firebase.fetch('/user/unimpersonate', {
        method: 'POST'
      });
      return result.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async getUserDetails(uuid) {
    try {
      let result = await Firebase.fetch('/user/' + uuid, {
        method: 'GET'
      });
      return result.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async getAdmins() {
    try {
      let result = await firebase.functions().httpsCallable('getAdmins')();
      return result.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async removeAdmin(uid) {
    try {
      let res = await firebase.functions().httpsCallable('removeAdmin')({ uid });
      return res;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async makeAdmin(uid) {
    try {
      let res = await firebase.functions().httpsCallable('makeAdmin')({ uid });
      return res;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async submitData(userData) {
    try {
      if (this.currentUserClaims.admin && this.currentUserClaims.impersonating) {
        console.log('Not submitting data because not ours')
        return;
      }

      const res = await firebase.firestore().collection('users').doc(this.__getId()).set(userData);
      return res;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async getClaims() {
    return firebase.auth().currentUser.getIdTokenResult(true)
      .then((idTokenResult) => {
        this.currentUserClaims = idTokenResult.claims;
        return idTokenResult.claims
      })
      .catch(e => {
        return Promise.reject(e);
      });
  }

  async getCrashReports(uid) {
    try {
      const res = await firebase.firestore().collection('users').doc(uid).collection('crashes').orderBy('when', 'desc').limit(10).get();
      let crashes = [];
      res.forEach(snap => {
        crashes.push(snap.data())
      });
      return crashes;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async claimSnapshotListener(authUser, useClaims) {
    return firebase.firestore()
        .collection('user-claims')
        .doc(authUser.uid)
        .onSnapshot(async document => {
          const claims = await this.getClaims();
          this.currentUserClaims = claims;
          let impersonate;
          if (claims.impersonating) {
            impersonate = await this.getUserDetails(claims.impersonating);
          }
          useClaims(claims, impersonate)
        })
  }

  __getId() {
    return this.currentUserClaims.impersonating ? this.currentUserClaims.impersonating : this.currentUserClaims.user_id;
  }
}

export default new UserApi();
